import { Text, TextTitle, TextDescription } from "components/Texts";

import { KeywordBar } from "components/bar";
import React from "react";
import colors from "styles/colors";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import formatMoney from "../../modules/utils/formatMoney";
import Separator from "../Separator";
import TextSubscript from "../TextSubscript";
import useCurrency from "modules/utils/useCurrency";

const KeywordZone = ({ data = [], example }) => {
  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();
  const currency = useCurrency();
  return (
    <StyledContainer>
      {example && <TextTitle size="12px">{t("__example")}</TextTitle>}
      {data.map((item, index) => (
        <StyledItem key={index} example={example}>
          <TextDescription size="10px">{t("__suggestion_keyword")}</TextDescription>
          <TextTitle size="14px" breakAll>
            {item.keyword}
          </TextTitle>
          <Separator margin="3px 0" />
          <TextDescription size="10px">{t("__suggestion_campaing")}</TextDescription>
          <Text size="12px" breakAll>
            {item.campaign}
          </Text>
          <Separator margin="4px 0" />
          <KeywordBar
            height={20}
            value1={item.campaign_avg_cpa}
            value2={item.avg_cpa}
            text1={t("__average_cpa")}
            text2="CPA"
          />
          <Separator margin="4px 0" />
          <TextDescription size="10px" color={colors.negative}>{`${t("__suggestion")}: `}</TextDescription>
          <Text size="14px" color={colors.negative}>
            {t("__cpa_is_above_avg")}
          </Text>
          <Separator margin="3px 0" />
          <TextSubscript
            valueText={`${t("__spending")}: ${formatMoney(item.cost)}`}
            subscriptText={currency}
            valueSize="14px"
            subscriptSize="10px"
            regular
          />
        </StyledItem>
      ))}
    </StyledContainer>
  );
};

export default KeywordZone;

const StyledContainer = styled.div`
  padding: 0 16px;
  margin: 24px 0 0;
`;

const StyledItem = styled.div.attrs((props) => ({
  opacity: props.example ? 0.5 : 1,
}))`
  margin: 0 0 32px;
  opacity: ${(props) => props.opacity};
`;
